module.exports = __webpack_public_path__ + "img/regole_prezzi_orari.8d3b97b6.svg";